import {
  ONE_DAY_OF_MS,
  ONE_MINUTE_OF_MS,
  ONE_SECOND_OF_MS,
} from "../utils/timeUtils";

// * use this multiplier for testing/debugging
// * e.g. multiply by a large number to slow down all network
// * refetch intervals, so we can count how many we expect
// ! reset back to 1 when finished debugging
const mu = 1;

// intervals at which we re-fetch / update data

// when a query fails, we try again fast, before returning to the default interval
export const FAST_RETRY_INTERVAL = 10 * ONE_SECOND_OF_MS * mu;
// exponential backoff maximum interval
export const SLOWEST_RETRY_INTERVAL = 5 * ONE_MINUTE_OF_MS * mu;

export const FETCH_ALL_LAST_DATA_DUMP_ROWS_INTERVAL =
  30 * ONE_SECOND_OF_MS * mu;
export const FETCH_SINGLE_LAST_DATA_DUMP_ROWS_INTERVAL =
  30 * ONE_SECOND_OF_MS * mu;
// data dump users
export const DEFAULT_DATA_DUMP_UPDATE_INTERVAL = 30 * ONE_SECOND_OF_MS * mu;
// data dump users on details page
export const HUBLET_VIEW_DATA_DUMP_POLL_INTERVAL = 10 * ONE_SECOND_OF_MS * mu;

export const CHECK_CURRENT_TREND_CHART_BARS_INTERVAL =
  30 * ONE_SECOND_OF_MS * mu;

export const CHECK_CURRENT_TREND_CHART_BARS_TRENDS_PAGE_INTERVAL =
  60 * ONE_SECOND_OF_MS * mu;

// data dump for PAI lot completion - output count since lot started
export const DATA_DUMP_FOR_FORECASTED_LOT_COMPLETION_INTERVAL =
  30 * ONE_SECOND_OF_MS * mu;

// shifts
export const DEFAULT_SHIFTS_GETTER_UPDATE_INTERVAL = ONE_DAY_OF_MS * mu; // fetch once per day if successful

// segments
export const DEFAULT_SEGMENTS_GETTER_UPDATE_INTERVAL =
  30 * ONE_SECOND_OF_MS * mu;

// machemetry: process groups & processes
export const MACHEMETRY_POLL_INTERVAL_TRENDS_PAGE = 10 * ONE_MINUTE_OF_MS * mu;
export const MACHEMETRY_POLL_INTERVAL_GROUP_TILES = 30 * ONE_SECOND_OF_MS * mu;
export const MACHEMETRY_POLL_INTERVAL_PROCESS_TILES =
  30 * ONE_SECOND_OF_MS * mu;

// aggregates from askr
export const AGGREGATES_POLL_INTERVAL = ONE_MINUTE_OF_MS * mu;
export const AGGREGATES_POLL_INTERVAL_TRENDS_PAGE = 10 * ONE_MINUTE_OF_MS * mu;

// The amount of time into the next shift we will wait before advancing
// the selected shift. We generally linger on the last state for awhile.
export const AUTO_NEXT_SHIFT_DELAY = 5 * ONE_MINUTE_OF_MS; // Five minutes
export const AUTO_NEXT_DAY_DELAY = 5 * ONE_MINUTE_OF_MS; // Five minutes ? not used anywhere

export const CUSTOMER_TILES_UPDATE_INTERVAL = 30 * ONE_SECOND_OF_MS * mu;

/** interval to fetch data for the allocation list */
export const ALLOCATION_FETCH_INTERVAL = 10 * ONE_SECOND_OF_MS * mu;

/** interval to fetch lot info data from midgard batchProgression query */
export const LOT_INFO_GETTER_INTERVAL = 5 * ONE_MINUTE_OF_MS * mu;

/** time to stay on one page while rotating pages */
export const DEFAULT_PAGE_ROTATION_INTERVAL = 1 * ONE_MINUTE_OF_MS * mu;

/** refresh the app once a day to reset any slow memory leaks */
export const SLOW_AUTO_REFRESH_INTERVAL = 1 * ONE_DAY_OF_MS * mu;

/** fetch data in ExpandedProcessTileDataGetter, used in ExpandedTileContent  */
export const MIDGARD_EXPANDED_TILE_POLL_INTERVAL = 30 * ONE_SECOND_OF_MS * mu;

/** update customer json every 5 minutes (used to map operator ids to operator names) */
export const CUSTOMER_JSON_POLL_INTERVAL = 5 * ONE_MINUTE_OF_MS * mu;

/** fetch dataDumpRows for sku+operator timeline */
export const DATA_DUMP_ROWS_FOR_SKU_OPERATOR_TIMELINE_INTERVAL =
  30 * ONE_SECOND_OF_MS * mu;
